<template>
    <div class="app">
        <div class="searchBox" v-if="unsearch">
            <img src="../../assets/images/saoma.png" alt="" @click="barcodeScan">
            <div class="search" @click="gotoSearchCard">
                <img src="../../assets/images/searchIcon.png" alt="">
                <input type="text" placeholder="搜索商铺会员卡" readonly>
            </div>
            <img src="../../assets/images/envelope.png" alt="" @click="goMessage">
            <i class="redPoint" v-if="haveMsg"></i>
        </div>
        <div class="searchingBox" v-else>
            <i class="el-icon-arrow-left" @click="backSearchCard"></i>
            <div class="searching">
                <input type="text" v-model.trim="keywords" placeholder="搜索商铺会员卡" maxlength="13">
                <img src="../../assets/images/searchIcon.png" @click="searchEvent" alt="">
            </div>
        </div>
        <div class="content">
            <div class="blank"></div>
            <div class="noCard" v-if="!haveCard">
                <img src="../../assets/images/search.png" alt="">
                <span>您还没有会员卡，发现商家加入吧!</span>
            </div>
            <div class="noCard" v-else-if="searchState && searchResult.length == 0">
                <img src="../../assets/images/search.png" alt="">
                <span>未能查询到当前商家您有会员卡的信息</span>
            </div>
            <div class="haveCard" v-else>
                <div class="cards">
                    <ul :style="{ height: (8 + 1.5 * searchResult.length) + 'rem' }">
                        <li v-for="(value,index) in searchResult" :key="index" :style="{ top: (-3.5 * index) + 'rem', 'z-index': index }" @click="goCardDetail(index)">
                            <div class="card">
                                <img :src="(value.type && value.type != 0 && value.type != 1) ? value.type : cardDefaultImg" alt="">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio } from "mint-ui";
import store from "@/vuex/store";
import { mapState } from "vuex";
import { showCardListAction, showUserAction, LoginUserAction } from '@/assets/js/api'
import { setUserInfoLocalStorage } from '@/assets/js/localStorage'
import { barcodeScanner } from '@/assets/js/nativeServices'
import cardDefaultImg from  '@/assets/images/bg-one.jpg'
import { addShopTags } from '@/assets/js/pushServices'

export default {
  name: 'cardBag',
  data() {
    return { 
        isSend:false, 
        haveCard:false,
        haveMsg:false, 
        cardArry:[],           // 会员卡列表信息 
        searchResult:[],
        beginIdx:0,            // 分页开始值
        num:0,                 // 分页次数
        loading:true,          // 是否加载 
        haveData:false,        // 是否有数据
        unsearch: true,
        keywords:'',
        searchState: false,
        cardDefaultImg: cardDefaultImg,
        cardCount: 0,
        msgCount: 0,
        userInfo: {
            sex: 0,
            avatar: '',
            nick: '',
            address: '',
            info: '',
            birthday: '',
            identity: '',
        },
        Toast: Toast({
            message: '加载中...',
            position: 'middle',
            duration: -1
        }),
    };
  },
  components: {
      "bottom":bottom,
  },
  methods: {
        // 搜索事件
        searchEvent(){
            this.searchState = true
            return this.searchResult = this.cardArry.filter(item => {
               if(item.shop.name.includes(this.keywords)){
                   return item
               }
           })        
        },
      barcodeScan () {
        barcodeScanner( result => {
          alert('We got a barcode\n' +
            'Result: ' + result.text + '\n' +
            'Format: ' + result.format + '\n' +
            'Cancelled: ' + result.cancelled)
        }, err => {
          alert('扫描失败：' + err)
        })
      },
      gotoSearchCard(){
        this.unsearch = false
      },
      backSearchCard () {
        this.keywords = ''
        this.searchState = false
        this.unsearch = true
      },
      // 跳转到消息列表页面
      goMessage()
      {
          this.$router.push({ name:"message" });
      },
      // 跳转到会员卡详情页面
      goCardDetail(index)
      {
          console.log('index',index);
          //var cardInfo = this.cardArray[index];
          this.$router.push(
            { 
              name:"cardDetail",
              query:
              {
                  index:index,
                  sid:this.cardArry[index].sid
              }
            });
      },
      getMemberCardList()
      {
        var maxRows = 0
        if (this.num !== 0) {
            this.beginIdx = maxRows*this.num
        }
        this.num++
        showCardListAction(this.beginIdx, maxRows).then(res=>{
            console.log("会员卡列表信息",res)
           // 5.接受到请求 改变id的值
            // httpSendQue[id] = 1; 
            this.Toast.close()
            if (res.s == 0) 
            {
            this.loading = false;              // 执行加载
            this.haveData = true;              
            if (this.cardArry)
            {
                res.card.forEach((v,i)=> { this.cardArry.push(v); })
            }
            else
            {
                this.cardArry = res.card
            }
            
            this.haveCard = (this.cardArry.length > 0) ? true : false

            this.searchResult = this.cardArry
            
            console.log('cardList',this.cardArry);
            // vuex存储卡列表
            this.$store.commit("newslist", this.cardArry );

            // let shopTags = []
            // for (let el in this.cardArry) {
                
            //     shopTags.push(el.sid)
            // }
            const cardSid = this.cardArry.map(i => {
                return i.sid
            })
            console.log('shopTags',cardSid)
            
            addShopTags(cardSid)
            
            if (res.card.length < maxRows)
            {
                this.loading = true
            }
            }
            else if (res.s == 1010)
            {
                this.haveCard=false
            }

            if (res.isMessage == 1)
            {
                this.haveMsg = true;
            } 
            else if (res.isMessage == 0)
            {
                this.haveMsg = false;
            }
        })
           .catch(error=>{
                // httpSendQue[id] = 1;   
                this.Toast.close()
                Toast({
                    message: '网络不给力',
                    position: 'middle',
                    duration:2000
                })
           })
      },
      // 获取用户通用信息
      getUserInfo () {
          LoginUserAction().then (res => {
              if (res.s == 0) {
                this.cardCount = res.cardCount
                this.msgCount = res.msgCount
                
                if (res.user) {
                var user = res.user
                this.userInfo.sex = user.sex ? user.sex : 0
                this.userInfo.avatar = user.avatar ? user.avatar : ''
                this.userInfo.nick = user.nick ? user.nick : ''
                this.userInfo.address = user.address ? user.address : ''
                this.userInfo.info = user.info ? user.info : ''
                this.userInfo.birthday = user.birthday ? user.birthday : ''
                this.userInfo.identity = user.identity ? user.identity : ''
                }
                
                this.haveMsg = (res.msgCount > 0)

                setUserInfoLocalStorage(JSON.stringify(this.userInfo))
              }
          })
      } 

  },
  mounted()
  {
      this.getMemberCardList()
      this.getUserInfo()
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.searchBox{
  height: 2.11rem;
  width: 100%;
  /* background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%); */
  position: fixed;
  z-index: 99;
  top: 0;
  background-color: #FFF;
  padding: 0 10px;
}
.searchBox :nth-child(1){
    width: 0.79rem;
    height: 0.79rem;
    position: relative;
    top: 0.5rem;
    left: 0.42rem;
}
.search{
    width: 6.61rem;
    height: 1.26rem;
    line-height: 1.26rem;
    border-radius: 0.05rem;
    border: 0.03rem solid rgba(255, 255, 255, 1);
    box-shadow: 0 0.05rem 0.05rem 0 rgba(0, 0, 0, 0.24);
    background-color: rgba(250, 250, 250, 1);
    margin-left: 1.63rem;
    position: relative;
    top: -0.65rem;
}
.search :nth-child(1){
    width: 0.45rem;
    height: 0.45rem;
    position: absolute;
    top: 0.39rem;
    left: 0.61rem;
}
.search :nth-child(2){
    width: 5.26rem;
    height: 0.79rem;
    border: none;
    position: absolute;
    top: 0.24rem;
    left: 1.26rem;
}
.searchBox :nth-child(3){
    width: 0.75rem;
    height: 0.60rem;
    position: relative;
    top: -1.63rem;
    left: 8.78rem;
}
.redPoint{
    display: block;
    border-radius: 50%;
    width: 0.26rem;
    height: 0.26rem;
    background-color: rgba(246, 34, 65, 1);
    position: relative;
    top: -2.45rem;
    left: 9.35rem;
}
.blank {
  height: 2.11rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  font-size: 0.42rem;
  /* background-color: rgba(0, 0, 0, 0.1); */
  height: 100%;
  width: 100%;
}
.noCard{
    width: 100%;
    height: 84%;
    position: relative;
}
.noCard :nth-child(1){
    width: 3.42rem;
    height: 3.16rem;
    position: absolute;
    top: 0.67rem;
    left: 3.13rem;
}
.noCard :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 4.68rem;
    left: 2.08rem;
}
 .card{
    border: 0.03rem solid #ffffff;
    border-radius: 0.55rem;
    width: 8.24rem;
    height: 5.05rem;
    position: relative;
    left: 0.87rem;
    overflow: hidden;
    color: #ffffff;
    background-color: coral;
}
.card :nth-child(1){
    width: 8.24rem;
    height: 5.05rem; 
    position: absolute; 
}
.cards ul li{
    position: relative;
}
.searchingBox{
  height: 1.89rem;
  width: 100%;
  /* background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%); */
  position: fixed;
  top: 0;
  padding-top: 0.32rem;
  z-index: 1;
}
.searchingBox :nth-child(1){
    font-size: 0.7rem;
    color: black;
    font-weight: 600;
    position: relative;
    top: 0.79rem;
    left: 0.2rem;
}
.searching{
    width: 7.5rem;
    height: 1.26rem;
    line-height: 1.26rem;
    border-radius: 0.05rem;
    border: 0.03rem solid rgba(255, 255, 255, 1);
    box-shadow: 0 0.05rem 0.05rem 0 rgba(0, 0, 0, 0.24);
    background-color: rgba(250, 250, 250, 1);
    margin-left: 1.63rem;
    position: relative;
    top: -0.65rem;
}
.searching :nth-child(2){
    width: 0.45rem;
    height: 0.45rem;
    position: absolute;
    top: 0.45rem;
    left: 6.79rem;
}
.searching :nth-child(1){
    width: 6.16rem;
    height: 0.79rem;
    font-size: 0.37rem;
    font-weight: normal;
    border: none;
    position: absolute;
    top: 0.26rem;
    left: 0.24rem;
    
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/cardBag.vue